import React, {useEffect, useState} from 'react';
import * as css from './ArrivalConfirmationChart.css';
import GenericPieChart from '../../genericPieChart/GenericPieChart';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import ArrivalConfirmationChartTemplate from './ArrivalConfirmationChartTemplate';
import {XHR_LOADING_STATE} from '../../../../../assets/constants/constants';
import {BRIGHT_GREEN, BRIGHT_RED, GOLDEN_POPPY, TANGERINE} from '../../../../../globalVariables/GlobalVariables';
import {getConfirmation} from '../../../../../redux/realtime/realtimeActions';
import setGlobalState from '../../../../../redux/setGlobalState';
import store from '../../../../../store';

function ArrivalConfirmationChart() {
    const {t} = useTranslation('suspendedConfirmation');
    const CONFIRMATION_TYPES = {NOT_RESPONDED: 0, MAYBE: 1, CONFIRMED: 2, CANCELED: 3};
    const {confirmation: confirmationArray, confirmationXHR,} = useSelector(({realtime}:any) => ({
        confirmation: realtime.event.confirmation,
        confirmationXHR: realtime.event.confirmationXHR,
    }));
    const [activeIndex, setActiveIndex] = useState(null);
    const isLoading = useSelector((s:any)=>s.realtime?.event?.confirmationXHR === XHR_LOADING_STATE);
    const confirmationMap = confirmationArray?.reduce((acc, item) => {
        acc[item.confirmationStatus] = item.count;
        return acc;
    }, {});
    const notResponded = confirmationMap[CONFIRMATION_TYPES.NOT_RESPONDED] || 0;
    const maybe = confirmationMap[CONFIRMATION_TYPES.MAYBE] || 0;
    const confirmed = confirmationMap[CONFIRMATION_TYPES.CONFIRMED] || 0;
    const canceled = confirmationMap[CONFIRMATION_TYPES.CANCELED] || 0;

    const total = confirmed + canceled + maybe + notResponded;
    const percentage = !total ? 0 : ((confirmed / total) * 100).toFixed(0);

    const chartData = [
        {name: t('confirmed'), value: confirmed, color: `${BRIGHT_GREEN}`.replace('#', '')},
        {name: t('canceled'), value: canceled, color: `${BRIGHT_RED}`.replace('#', '')},
        {name: t('maybe'), value: maybe, color: `${TANGERINE}`.replace('#', '')},
        {name: t('notResponded'), value: notResponded, color: `${GOLDEN_POPPY}`.replace('#', '')},
    ];

    useEffect(() => {
        if(confirmationArray.length < 1 && !confirmationXHR) getConfirmation().then();
    },[]);

    const inlineRect = (
        <>
            <css.percentage>{percentage}%</css.percentage>
            <css.ratio>{`${confirmed} ${t('outOf')} ${total}`}</css.ratio>
        </>
    );
    if(isLoading) {
        return <ArrivalConfirmationChartTemplate />;
    }
    const sendConfirmations =  () => {
        setGlobalState('crm', {...store.getState().crm, queryFilter: {}, freeFilter: ''});
        setGlobalState('ui.show.isOpenArrivalConfirmation', true);
    };
    return (
        <css.wrap>
            <css.header>
                <css.text>{t('arrivalConfirmationTitle')}</css.text>
                <css.button onClick={sendConfirmations} className={'free-color'}>
                    {t('sendReminder')}
                </css.button>
            </css.header>
            <css.chartContainer>
                <GenericPieChart
                    data={chartData}
                    dataKey='value'
                    activeIndex={{activeIndex, setActiveIndex}}
                    inlineRect={inlineRect}
                    hoverState={true}
                />
            </css.chartContainer>
            {confirmationArray.length > 0 && <css.legend>
                <css.legendItem color={`${BRIGHT_GREEN}`}>{`${t('confirmed')}: ${confirmed} ${t('participants')}`}</css.legendItem>
                <css.legendItem color={`${GOLDEN_POPPY}`}>{`${t('notResponded')}: ${notResponded} ${t('participants')}`}</css.legendItem>
                <css.legendItem color={`${TANGERINE}`}>{`${t('maybe')}: ${maybe} ${t('participants')}`}</css.legendItem>
                <css.legendItem color={`${BRIGHT_RED}`}>{`${t('canceled')}: ${canceled} ${t('participants')}`}</css.legendItem>
            </css.legend>}
        </css.wrap>
    );
}

export default ArrivalConfirmationChart;
